/** Vraagt eenmalig toestemming voor browser-meldingen als de gebruiker nog niets gekozen heeft. */
export function requestNotificationPermission() {
	if (typeof window == "undefined" || !("Notification" in window)) return;
	if (window.Notification.permission == "default") {
		window.Notification.requestPermission();
	}
}
